import { render, staticRenderFns } from "./TaskProcessInspectionList.vue?vue&type=template&id=ce2c0360&scoped=true&"
import script from "./TaskProcessInspectionList.vue?vue&type=script&lang=js&"
export * from "./TaskProcessInspectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2c0360",
  null
  
)

export default component.exports